import React, { createElement } from 'react';
import style from './index.module.scss';
import Col from '../layout/Col'

export interface GridProps {
    gridList: Array<number | string>; // 比例, 如果是带px的，就说明是个具体值
    gap: number; // 间距
}

interface FinalStyle {
    width?: number | string;
    flex?: number | string;
    marginRight?: string;
}

const Grid: React.FC<GridProps> = (props) => {
    const { gridList, gap } = props;

    console.log(props)

    const GetStyle = (grid, index) => {
        const finalStyle: FinalStyle = {};
        if (grid.toString().includes('px')) {
            finalStyle.width = grid;
        } else {
            finalStyle.flex = grid;
        }
        if (index < gridList.length - 1) {
            finalStyle.marginRight = `${gap}px`;
        }

        return finalStyle;
    };

    return (
        <div className={style.Grid}>
            <div className={style.container}>
                {gridList &&
                    gridList.map((grid, index) => {
                        const style = GetStyle(grid, index);
                        console.log(props.children[index])
                        return (
                            <div style={{ ...style }} key={index}>
                                {
                                    props.children[index] ? <Col width={{ type: 'percentage', size: 100 }}>{props.children[index]}</Col> :
                                        <div className="lc-container-placeholder">拖拽组件或模板到这里</div>
                                }
                                {/*<Container />*/}
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};

Grid.displayName = '布局容器';

export default Grid;
